/**
 * Card-validity helpers for the SaaS billing profile.
 *
 * ``GET /billing/profile`` returns ``payment_methods`` as
 * ``[{ id, brand, last4, exp_month, exp_year, is_primary }]``; the expiry
 * fields are integers, ``0`` when Stripe did not supply them.
 */

const toPositiveInt = (value) => {
    const number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
};

/**
 * A card is expired once ``now`` is past its ``exp_month``/``exp_year``
 * (cards stay valid through the last day of the expiry month). A method
 * without expiry data is not reported as expired: we cannot prove it is.
 */
export function isPaymentMethodExpired(paymentMethod, now = new Date()) {
    const expYear = toPositiveInt(paymentMethod?.exp_year);
    const expMonth = toPositiveInt(paymentMethod?.exp_month);
    if (expYear === null || expMonth === null) return false;
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    return expYear < year || (expYear === year && expMonth < month);
}

/** True when at least one configured card has not expired. */
export function hasValidPaymentMethod(paymentMethods, now = new Date()) {
    if (!Array.isArray(paymentMethods)) return false;
    return paymentMethods.some((method) => method && !isPaymentMethodExpired(method, now));
}
